__turbopack_context__.v({
  "fourCharacters": "fygEuW_fourCharacters",
});
